/** Message moderation policy — shared between worker and client copy. */

export const MESSAGE_MODERATION_VERSION = '2026-07-23.3'

export const MESSAGE_STRIKE_LIMIT = 3
export const MESSAGE_SUSPENSION_HOURS = 24

export type MessageStrikeInfo = {
  strikeStreak: number
  strikeLimit: number
  suspendedUntil: string | null
  canSend: boolean
}

export type MessageBlockCategory =
  | 'outside_contact'
  | 'threat'
  | 'self_harm'
  | 'harassment'
  | 'sexual'
  | 'spam'
  | 'extremism'
  | 'scan_unavailable'
  | 'image_blocked'

export const MESSAGE_BLOCK_USER_COPY: Record<MessageBlockCategory, string> = {
  outside_contact:
    'Contact info and off-platform links aren’t allowed in messages. Keep the conversation on Pairvelle.',
  threat: 'Threats and violent language aren’t allowed.',
  self_harm: 'Messages about self-harm aren’t allowed. If you or someone else is in crisis, please contact local emergency services.',
  harassment: 'Harassment, hate speech, and insults aren’t allowed.',
  sexual: 'Graphic or explicit sexual language isn’t allowed. Mild flirting and compliments are fine.',
  spam: 'This message looks like spam or a scam.',
  extremism: 'Extremist content isn’t allowed.',
  scan_unavailable: 'We couldn’t verify this message right now. Try again in a moment.',
  image_blocked: 'This photo couldn’t be sent — it may violate our community standards.',
}

export function strikeWarningCopy(streak: number, limit: number): string {
  const remaining = Math.max(0, limit - streak)
  if (remaining === 0) return 'Messaging is paused — see countdown below.'
  if (remaining === 1) {
    return `Strike ${streak} of ${limit} — one more blocked message in a row pauses messaging for ${MESSAGE_SUSPENSION_HOURS} hours.`
  }
  return `Strike ${streak} of ${limit} — ${remaining} more blocked messages in a row will pause messaging for ${MESSAGE_SUSPENSION_HOURS} hours.`
}
